































import formatDate from 'date-fns/format';
import { defineComponent } from '@vue/composition-api';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import { getI18nSettingsStore } from '@front-app/modules/i18n/store/i18nSettings';
import { PhoenixLocale } from '@front-app/modules/i18n/model/locale';
import { loadAndSetLocale } from '@front-app/modules/i18n/util/loaders';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import LanguagePicker from './inputs/LanguagePicker.vue';

const links = [
	{
		text: 'user-menu.contact-us',
		href: '/contact-us/',
	},
	{
		text: 'links.privacy-policy',
		href: `${
			process.env.VUE_APP_TRAPP_PUBLIC_URL
		}/legal/timedright-privacy-policy`,
	},
	{
		text: 'terms-of-use',
		href: `${process.env.VUE_APP_TRAPP_PUBLIC_URL}/legal/website-terms-of-use`,
	},
	{
		text: 'links.trademarks-and-copyright',
		href: `${
			process.env.VUE_APP_TRAPP_PUBLIC_URL
		}/legal/trademark-and-copyright-usage-policy`,
	},
];

export default defineComponent({
	components: {
		PublicLink,
		LanguagePicker,
	},
	setup(props, ctx) {
		const {
			getLocaleSetting,
			getDisplayLocale,
			setLocaleSetting,
		} = getI18nSettingsStore();
		const updateLanguage = async (newVal: PhoenixLocale) => {
			setLocaleSetting(newVal);
			await loadAndSetLocale(ctx.root.$i18n, getDisplayLocale());
		};
		return {
			languageSelectionDropdownPosition: DropdownPosition.TOP_RIGHT,
			updateLanguage,
			getLocaleSetting,
			links,
			version: process.env.VUE_APP_VERSION,
			year: formatDate(Date.now(), 'yyyy'),
		};
	},
});
